import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('alphaNumWithSpaces', /^[0-9a-zA-Z\s]*$/);
